import React, { ReactNode, createContext, useContext, useMemo } from 'react';
import { IPQMappingContent } from '../../../types/shared/PrequalificationDataEntry';
import { PathUtils } from '@adobe/aem-spa-page-model-manager';

interface IPqDataManagerProviderProps {
    children: ReactNode;
}

interface IPQMappingContentValue {
    pqMappingContent: IPQMappingContent;
}

const PqDataManagerContext = createContext<IPQMappingContentValue>({
    pqMappingContent: {
        enableMBPointsMF: 'false',
        enablePremiumCardDisclosure: false,
        premiumCardDisclosure: '',
    },
});

export default function PqDataManagerProvider({
    children,
}: IPqDataManagerProviderProps) {
    return (
        <PqDataManagerContext.Provider
            value={useMemo(() => {
                const pqMappingContent =
                    PathUtils.getMetaPropertyValue('PQMappingContent');

                return {
                    pqMappingContent: pqMappingContent
                        ? JSON.parse(pqMappingContent)
                        : {},
                };
            }, [])}
        >
            {children}
        </PqDataManagerContext.Provider>
    );
}

/**
 * Content pulled from pqdataentry content fragments
 */
export const usePqDataManager = () => useContext(PqDataManagerContext);
